export const legalDocuments = {
  "privacy": {
    "slug": "privacy",
    "title": "Политика в отношении обработки персональных данных",
    "label": "Политика конфиденциальности",
    "eyebrow": "Правовые документы",
    "updated": "10 сентября 2026",
    "blocks": [
      {
        "type": "heading",
        "number": "1",
        "text": "Общие положения"
      },
      {
        "type": "paragraph",
        "text": "Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006. № 152-ФЗ «О персональных данных» (далее — Закон о персональных данных) и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые Карпенко Максимом Викторовичем (далее — Оператор)."
      },
      {
        "type": "paragraph",
        "number": "1.1.",
        "text": "Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну."
      },
      {
        "type": "paragraph",
        "number": "1.2.",
        "text": "Настоящая политика Оператора в отношении обработки персональных данных (далее — Политика) применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта https://пантеон.com."
      },
      {
        "type": "heading",
        "number": "2",
        "text": "Основные понятия, используемые в Политике"
      },
      {
        "type": "paragraph",
        "number": "2.1.",
        "text": "Автоматизированная обработка персональных данных — обработка персональных данных с помощью средств вычислительной техники."
      },
      {
        "type": "paragraph",
        "number": "2.2.",
        "text": "Блокирование персональных данных — временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных)."
      },
      {
        "type": "paragraph",
        "number": "2.3.",
        "text": "Веб-сайт — совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу https://пантеон.com."
      },
      {
        "type": "paragraph",
        "number": "2.4.",
        "text": "Информационная система персональных данных — совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств."
      },
      {
        "type": "paragraph",
        "number": "2.5.",
        "text": "Обезличивание персональных данных — действия, в результате которых невозможно определить без использования дополнительной информации принадлежность персональных данных конкретному Пользователю или иному субъекту персональных данных."
      },
      {
        "type": "paragraph",
        "number": "2.6.",
        "text": "Обработка персональных данных — любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных."
      },
      {
        "type": "paragraph",
        "number": "2.7.",
        "text": "Оператор — государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и/или осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными."
      },
      {
        "type": "paragraph",
        "number": "2.8.",
        "text": "Персональные данные — любая информация, относящаяся прямо или косвенно к определенному или определяемому Пользователю веб-сайта https://пантеон.com."
      },
      {
        "type": "paragraph",
        "number": "2.9.",
        "text": "Персональные данные, разрешенные субъектом персональных данных для распространения, — персональные данные, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных путем дачи согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения в порядке, предусмотренном Законом о персональных данных (далее — персональные данные, разрешенные для распространения)."
      },
      {
        "type": "paragraph",
        "number": "2.10.",
        "text": "Пользователь — любой посетитель веб-сайта https://пантеон.com."
      },
      {
        "type": "paragraph",
        "number": "2.11.",
        "text": "Предоставление персональных данных — действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц."
      },
      {
        "type": "paragraph",
        "number": "2.12.",
        "text": "Распространение персональных данных — любые действия, направленные на раскрытие персональных данных неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными данными неограниченного круга лиц, в том числе обнародование персональных данных в средствах массовой информации, размещение в информационно-телекоммуникационных сетях или предоставление доступа к персональным данным каким-либо иным способом."
      },
      {
        "type": "paragraph",
        "number": "2.13.",
        "text": "Трансграничная передача персональных данных — передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому или иностранному юридическому лицу."
      },
      {
        "type": "paragraph",
        "number": "2.14.",
        "text": "Уничтожение персональных данных — любые действия, в результате которых персональные данные уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в информационной системе персональных данных и/или уничтожаются материальные носители персональных данных."
      },
      {
        "type": "heading",
        "number": "3",
        "text": "Основные права и обязанности Оператора"
      },
      {
        "type": "paragraph",
        "number": "3.1.",
        "text": "Оператор имеет право:"
      },
      {
        "type": "bullet",
        "text": "получать от субъекта персональных данных достоверные информацию и/или документы, содержащие персональные данные;"
      },
      {
        "type": "bullet",
        "text": "в случае отзыва субъектом персональных данных согласия на обработку персональных данных, а также, направления обращения с требованием о прекращении обработки персональных данных, Оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в Законе о персональных данных;"
      },
      {
        "type": "bullet",
        "text": "самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения обязанностей, предусмотренных Законом о персональных данных и принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено Законом о персональных данных или другими федеральными законами."
      },
      {
        "type": "paragraph",
        "number": "3.2.",
        "text": "Оператор обязан:"
      },
      {
        "type": "bullet",
        "text": "предоставлять субъекту персональных данных по его просьбе информацию, касающуюся обработки его персональных данных;"
      },
      {
        "type": "bullet",
        "text": "организовывать обработку персональных данных в порядке, установленном действующим законодательством РФ;"
      },
      {
        "type": "bullet",
        "text": "отвечать на обращения и запросы субъектов персональных данных и их законных представителей в соответствии с требованиями Закона о персональных данных;"
      },
      {
        "type": "bullet",
        "text": "сообщать в уполномоченный орган по защите прав субъектов персональных данных по запросу этого органа необходимую информацию в течение 10 дней с даты получения такого запроса;"
      },
      {
        "type": "bullet",
        "text": "публиковать или иным образом обеспечивать неограниченный доступ к настоящей Политике в отношении обработки персональных данных;"
      },
      {
        "type": "bullet",
        "text": "принимать правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от иных неправомерных действий в отношении персональных данных;"
      },
      {
        "type": "bullet",
        "text": "прекратить передачу (распространение, предоставление, доступ) персональных данных, прекратить обработку и уничтожить персональные данные в порядке и случаях, предусмотренных Законом о персональных данных;"
      },
      {
        "type": "bullet",
        "text": "исполнять иные обязанности, предусмотренные Законом о персональных данных."
      },
      {
        "type": "heading",
        "number": "4",
        "text": "Основные права и обязанности субъектов персональных данных"
      },
      {
        "type": "paragraph",
        "number": "4.1.",
        "text": "Субъекты персональных данных имеют право:"
      },
      {
        "type": "bullet",
        "text": "получать информацию, касающуюся обработки его персональных данных, за исключением случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту персональных данных Оператором в доступной форме, и в них не должны содержаться персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. Перечень информации и порядок ее получения установлен Законом о персональных данных;"
      },
      {
        "type": "bullet",
        "text": "требовать от оператора уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав;"
      },
      {
        "type": "bullet",
        "text": "выдвигать условие предварительного согласия при обработке персональных данных в целях продвижения на рынке товаров, работ и услуг;"
      },
      {
        "type": "bullet",
        "text": "на отзыв согласия на обработку персональных данных, а также, на направление требования о прекращении обработки персональных данных;"
      },
      {
        "type": "bullet",
        "text": "обжаловать в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке неправомерные действия или бездействие Оператора при обработке его персональных данных;"
      },
      {
        "type": "bullet",
        "text": "на осуществление иных прав, предусмотренных законодательством РФ."
      },
      {
        "type": "paragraph",
        "number": "4.2.",
        "text": "Субъекты персональных данных обязаны:"
      },
      {
        "type": "bullet",
        "text": "предоставлять Оператору достоверные данные о себе;"
      },
      {
        "type": "bullet",
        "text": "сообщать Оператору об уточнении (обновлении, изменении) своих персональных данных."
      },
      {
        "type": "paragraph",
        "number": "4.3.",
        "text": "Лица, передавшие Оператору недостоверные сведения о себе, либо сведения о другом субъекте персональных данных без согласия последнего, несут ответственность в соответствии с законодательством РФ."
      },
      {
        "type": "heading",
        "number": "5",
        "text": "Принципы обработки персональных данных"
      },
      {
        "type": "paragraph",
        "number": "5.1.",
        "text": "Обработка персональных данных осуществляется на законной и справедливой основе."
      },
      {
        "type": "paragraph",
        "number": "5.2.",
        "text": "Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных."
      },
      {
        "type": "paragraph",
        "number": "5.3.",
        "text": "Не допускается объединение баз данных, содержащих персональные данные, обработка которых осуществляется в целях, несовместимых между собой."
      },
      {
        "type": "paragraph",
        "number": "5.4.",
        "text": "Обработке подлежат только персональные данные, которые отвечают целям их обработки."
      },
      {
        "type": "paragraph",
        "number": "5.5.",
        "text": "Содержание и объем обрабатываемых персональных данных соответствуют заявленным целям обработки. Не допускается избыточность обрабатываемых персональных данных по отношению к заявленным целям их обработки."
      },
      {
        "type": "paragraph",
        "number": "5.6.",
        "text": "При обработке персональных данных обеспечивается точность персональных данных, их достаточность, а в необходимых случаях и актуальность по отношению к целям обработки персональных данных. Оператор принимает необходимые меры и/или обеспечивает их принятие по удалению или уточнению неполных или неточных данных."
      },
      {
        "type": "paragraph",
        "number": "5.7.",
        "text": "Хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных. Обрабатываемые персональные данные уничтожаются либо обезличиваются по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено федеральным законом."
      },
      {
        "type": "heading",
        "number": "6",
        "text": "Цели обработки персональных данных"
      },
      {
        "type": "paragraph",
        "text": "Оператор обрабатывает персональные данные посетителей сайта, зарегистрированных Пользователей, владельцев каналов и стримеров, авторов и участников обсуждений, участников мероприятий, лиц, обращающихся в поддержку, заявителей, лиц, в отношении которых поданы жалобы, а также модераторов и администраторов. Данные поступают непосредственно от субъекта, формируются при использовании сервисов или получаются от иных лиц при наличии законного основания.",
        "number": "6.1."
      },
      {
        "type": "paragraph",
        "text": "Для перечисленных ниже целей применяются автоматизированные сбор, запись, систематизация, накопление, хранение, уточнение, извлечение, использование, предоставление доступа уполномоченным лицам и обработчикам, блокирование, удаление и уничтожение данных. Распространение допускается только в случаях, прямо указанных в настоящей Политике, по инициативе Пользователя либо при наличии иного предусмотренного законом основания.",
        "number": "6.2."
      },
      {
        "type": "subheading",
        "number": "6.3",
        "text": "Регистрация, аутентификация и управление учетной записью"
      },
      {
        "type": "definition",
        "term": "Цель.",
        "text": "Создание и ведение учетной записи, подтверждение электронной почты, вход, обновление и восстановление учетных данных, управление сессиями и предотвращение несанкционированного доступа."
      },
      {
        "type": "definition",
        "term": "Субъекты и данные.",
        "text": "Зарегистрированные Пользователи и лица, начинающие регистрацию; адрес электронной почты, логин, внутренний идентификатор, хеш пароля, идентификаторы сессий и токенов, IP-адрес, User-Agent, даты и результаты входов, подтверждений и попыток восстановления."
      },
      {
        "type": "definition",
        "term": "Правовые основания.",
        "text": "Заключение и исполнение Пользовательского соглашения, согласие субъекта в предусмотренных законом случаях, исполнение обязанностей Оператора и законный интерес в обеспечении безопасности сервиса при условии соблюдения прав субъекта."
      },
      {
        "type": "definition",
        "term": "Срок.",
        "text": "В течение срока действия учетной записи; после ее прекращения — не более 30 дней, если более длительное хранение не требуется законом или для рассмотрения обоснованных требований. Журналы безопасности хранятся не более одного года."
      },
      {
        "type": "subheading",
        "number": "6.4",
        "text": "Профиль и социальные функции"
      },
      {
        "type": "definition",
        "term": "Цель.",
        "text": "Создание и отображение профиля, поиск пользователей, управление подписками, значками, настройками и уведомлениями."
      },
      {
        "type": "definition",
        "term": "Субъекты и данные.",
        "text": "Зарегистрированные Пользователи; логин, отображаемое имя, внутренний идентификатор, изображение профиля и фона, описание и иные сведения, добровольно добавленные в профиль, сведения о подписках, подписчиках, значках и пользовательских настройках."
      },
      {
        "type": "definition",
        "term": "Правовые основания.",
        "text": "Исполнение Пользовательского соглашения, действия Пользователя по настройке профиля и согласие — в случаях, когда оно требуется для публикации персональных данных."
      },
      {
        "type": "definition",
        "term": "Срок.",
        "text": "До удаления соответствующих сведений Пользователем либо прекращения учетной записи; технические резервные копии очищаются не позднее 90 дней после удаления."
      },
      {
        "type": "subheading",
        "number": "6.5",
        "text": "Стриминг, записи и пользовательские медиаматериалы"
      },
      {
        "type": "definition",
        "term": "Цель.",
        "text": "Организация прямых трансляций и просмотра, создание записей, VOD, клипов и превью, загрузка, хранение, обработка и выдача медиаматериалов, учет зрителей и техническое обеспечение качества воспроизведения."
      },
      {
        "type": "definition",
        "term": "Субъекты и данные.",
        "text": "Стримеры, зрители, авторы и лица, попавшие в пользовательский контент; идентификаторы аккаунта и канала, настройки и метаданные трансляций, сведения о просмотрах и подключениях, загруженные изображения, аудио и видео, голос, изображение, тексты и иные сведения внутри контента."
      },
      {
        "type": "definition",
        "term": "Правовые основания.",
        "text": "Исполнение Пользовательского соглашения, действия Пользователя по загрузке или публикации контента, согласие субъекта — когда оно требуется законом, а также законный интерес Оператора в обеспечении работы и безопасности сервиса."
      },
      {
        "type": "definition",
        "term": "Срок.",
        "text": "До удаления материала его автором, прекращения учетной записи или удаления Оператором по законному основанию. Технические копии удаленных материалов уничтожаются не позднее 90 дней, если иной срок не установлен законом."
      },
      {
        "type": "subheading",
        "number": "6.6",
        "text": "Общение и взаимодействия"
      },
      {
        "type": "definition",
        "term": "Цель.",
        "text": "Работа чатов, комментариев, реакций, опросов, рейдов, канальных наград и иных социальных функций, а также доставка системных сообщений."
      },
      {
        "type": "definition",
        "term": "Субъекты и данные.",
        "text": "Пользователи и авторы контента; идентификатор, логин и отображаемое имя, тексты сообщений и комментариев, прикрепленные материалы, реакции, сведения об участии в опросах, наградах и иных действиях, дата и время совершения действия."
      },
      {
        "type": "definition",
        "term": "Правовые основания.",
        "text": "Исполнение Пользовательского соглашения и действия Пользователя по созданию или отправке контента; согласие — для обработки или распространения данных, когда оно требуется законом."
      },
      {
        "type": "definition",
        "term": "Срок.",
        "text": "До удаления контента Пользователем или Оператором либо прекращения учетной записи; сведения, необходимые для разрешения споров и применения мер модерации, могут храниться не более трех лет после соответствующего события."
      },
      {
        "type": "subheading",
        "number": "6.7",
        "text": "Персонализация, рекомендации и статистика"
      },
      {
        "type": "definition",
        "term": "Цель.",
        "text": "Формирование рекомендаций трансляций и клипов, учет популярности материалов, работа истории взаимодействий, начисление канальных баллов, подсчет зрителей и улучшение функций сервиса."
      },
      {
        "type": "definition",
        "term": "Субъекты и данные.",
        "text": "Посетители и Пользователи; идентификатор аккаунта или сессии, подписки, просмотры, реакции, взаимодействия с трансляциями и клипами, сведения о начислениях и использовании канальных баллов, технические временные метки."
      },
      {
        "type": "definition",
        "term": "Правовые основания.",
        "text": "Исполнение Пользовательского соглашения и законный интерес Оператора в предоставлении релевантного и устойчиво работающего сервиса при условии соблюдения прав и свобод субъекта."
      },
      {
        "type": "definition",
        "term": "Срок.",
        "text": "Идентифицируемая история — в течение срока действия учетной записи и не более 30 дней после ее прекращения; обезличенная агрегированная статистика может храниться без ограничения срока, если она не позволяет определить субъекта."
      },
      {
        "type": "subheading",
        "number": "6.8",
        "text": "Поддержка, модерация, безопасность и исполнение требований закона"
      },
      {
        "type": "definition",
        "term": "Цель.",
        "text": "Рассмотрение обращений и жалоб, расследование нарушений, ограничение доступа, защита Пользователей и инфраструктуры, предотвращение спама и злоупотреблений, ведение аудита действий модераторов, исполнение законных запросов государственных органов и защита прав Оператора и третьих лиц."
      },
      {
        "type": "definition",
        "term": "Субъекты и данные.",
        "text": "Заявители, Пользователи, лица, в отношении которых направлены жалобы, модераторы и администраторы; контактные и учетные данные, содержание обращения или жалобы, спорный контент, журналы действий, IP-адрес, User-Agent, даты, причины, результаты проверок и примененные меры."
      },
      {
        "type": "definition",
        "term": "Правовые основания.",
        "text": "Исполнение Пользовательского соглашения, выполнение установленных законом обязанностей и законный интерес в защите сервиса и прав его участников."
      },
      {
        "type": "definition",
        "term": "Срок.",
        "text": "Обращения, жалобы, решения и связанные журналы — не более трех лет после завершения рассмотрения; технические журналы безопасности — не более одного года, если более длительное хранение не требуется законом или продолжающимся спором."
      },
      {
        "type": "subheading",
        "number": "6.9",
        "text": "Мероприятия и Pixel Battle"
      },
      {
        "type": "definition",
        "term": "Цель.",
        "text": "Проведение мероприятий, прием и рассмотрение заявок, назначение модераторов, работа команд, холста, рейтингов, голосовых сообщений и награждений, а также обеспечение честности участия."
      },
      {
        "type": "definition",
        "term": "Субъекты и данные.",
        "text": "Участники, капитаны команд, кандидаты, модераторы и администраторы; идентификатор и логин аккаунта, сведения о заявке и команде, действия и результаты участия, размещенные пиксели и начисленные баллы, голосовые сообщения, временные метки и модерационные сведения."
      },
      {
        "type": "definition",
        "term": "Правовые основания.",
        "text": "Исполнение Пользовательского соглашения и правил соответствующего мероприятия, действия Пользователя по участию, а также законный интерес Оператора в предотвращении злоупотреблений."
      },
      {
        "type": "definition",
        "term": "Срок.",
        "text": "Данные текущего мероприятия — до его завершения и подведения итогов; результаты и сведения о награждениях — в течение срока действия учетной записи; жалобы и модерационные решения — не более трех лет."
      },
      {
        "type": "subheading",
        "number": "6.10",
        "text": "Идентификация устройства и антифрод Pixel Battle"
      },
      {
        "type": "definition",
        "term": "Цель.",
        "text": "Выявление совместного использования устройств несколькими аккаунтами, частого переключения аккаунтов или устройств и связанных злоупотреблений; формирование оценки риска для последующей проверки уполномоченным администратором."
      },
      {
        "type": "definition",
        "term": "Данные.",
        "text": "Случайный идентификатор браузера в cookie pb_device, созданный из него односторонний HMAC-псевдоним, связи между псевдонимом устройства и идентификаторами аккаунтов, даты первого и последнего наблюдения, количество связанных аккаунтов и устройств, временные признаки переключений, оценка риска и примененные администратором меры."
      },
      {
        "type": "definition",
        "term": "Особенности.",
        "text": "Исходное значение cookie не передается в Pixel Battle: используется устойчивый HMAC-псевдоним. Оценка риска сама по себе не является достаточным основанием для автоматической блокировки; решение принимается уполномоченным администратором после проверки. Пользователь вправе направить возражение и запросить пересмотр решения по адресу help@pantheone.ru."
      },
      {
        "type": "definition",
        "term": "Правовые основания.",
        "text": "Исполнение правил мероприятия и законный интерес Оператора и участников в защите сервиса от злоупотреблений при условии соблюдения прав и свобод субъекта."
      },
      {
        "type": "definition",
        "term": "Срок.",
        "text": "Cookie и активные связи «аккаунт — устройство» хранятся 180 дней с последнего наблюдения; краткосрочные признаки переключений — 15 минут; сведения о подтвержденной блокировке устройства — до отмены блокировки по результатам пересмотра либо прекращения соответствующей функции."
      },
      {
        "type": "subheading",
        "number": "6.11",
        "text": "AI-бот Dima"
      },
      {
        "type": "definition",
        "term": "Цель.",
        "text": "Формирование автоматического ответа в чате на каналах, где владелец включил AI-бота."
      },
      {
        "type": "definition",
        "term": "Субъекты и данные.",
        "text": "Авторы сообщений и владелец канала; идентификатор канала, отображаемые имена, тексты сообщений и необходимый контекст беседы, настройки бота."
      },
      {
        "type": "definition",
        "term": "Правовые основания.",
        "text": "Исполнение Пользовательского соглашения, действия Пользователя в чате и законный интерес в предоставлении включенной владельцем канала функции. Передача контекста внешнему поставщику модели допускается только после раскрытия в Политике или отдельном уведомлении сведений о поставщике, составе данных, месте и сроке обработки и применимом основании передачи."
      },
      {
        "type": "definition",
        "term": "Срок.",
        "text": "Настройки бота — до его отключения или прекращения учетной записи; контекст сообщений — только в объеме и в течение срока, необходимых для формирования ответа, если иной срок не раскрыт Пользователю до начала обработки."
      },
      {
        "type": "subheading",
        "number": "6.12",
        "text": "Электронные сообщения"
      },
      {
        "type": "definition",
        "term": "Цель.",
        "text": "Отправка кодов подтверждения, уведомлений о безопасности, восстановлении доступа, статусе заявок и иных сервисных сообщений. Рекламные и информационные рассылки осуществляются только при наличии отдельного предварительного согласия."
      },
      {
        "type": "definition",
        "term": "Данные.",
        "text": "Адрес электронной почты, тип и время сообщения, результат отправки, IP-адрес и User-Agent при совершении связанных действий."
      },
      {
        "type": "definition",
        "term": "Правовые основания.",
        "text": "Исполнение Пользовательского соглашения и обеспечение безопасности; для рекламной рассылки — отдельное согласие, которое можно отозвать."
      },
      {
        "type": "definition",
        "term": "Срок.",
        "text": "Журналы отправки и попыток восстановления доступа — не более одного года; данные рассылки — до отзыва согласия или прекращения соответствующей рассылки."
      },
      {
        "type": "subheading",
        "number": "6.13",
        "text": "Cookie и аналогичные технологии"
      },
      {
        "type": "paragraph",
        "text": "Оператор применяет следующие технические средства:",
        "number": "6.13.1."
      },
      {
        "type": "definition",
        "term": "session.",
        "text": "Защищенная подписанная и зашифрованная cookie с данными, необходимыми для аутентификации и обновления сессии. Срок действия — 6 суток; область действия — домен пантеон.com и путь «/»; флаги HttpOnly, Secure и SameSite=Strict. Cookie необходима для входа и работы авторизованных функций."
      },
      {
        "type": "definition",
        "term": "password_reset.",
        "text": "Защищенная cookie с временным билетом восстановления доступа. Срок действия — 5 минут; область действия — домен пантеон.com и путь «/»; флаги HttpOnly, Secure и SameSite=Strict. Cookie необходима для безопасного завершения процедуры восстановления."
      },
      {
        "type": "definition",
        "term": "pb_device.",
        "text": "Подписанная HttpOnly-cookie со случайным идентификатором браузера для антифрода Pixel Battle. Срок действия — 180 дней; область действия — домен пантеон.com и путь «/»; флаги Secure и SameSite=Lax. Связанная обработка описана в пункте 6.10."
      },
      {
        "type": "definition",
        "term": "localStorage.",
        "text": "Локальное хранилище браузера используется для сохранения выбранной громкости проигрывателя. Значение остается на устройстве до изменения или очистки Пользователем и само по себе не передается Оператору."
      },
      {
        "type": "definition",
        "term": "sessionStorage.",
        "text": "Может использоваться для временного состояния подключения чата; сведения удаляются браузером после завершения сессии соответствующей вкладки."
      },
      {
        "type": "paragraph",
        "text": "Правовым основанием применения session и password_reset является необходимость исполнения Пользовательского соглашения и обеспечения безопасности. Для pb_device используются основания, указанные в пункте 6.10. Необязательные аналитические, рекламные или иные средства отслеживания не устанавливаются до получения отдельного информированного согласия Пользователя.",
        "number": "6.13.2."
      },
      {
        "type": "paragraph",
        "text": "Пользователь может удалить cookie и данные локального хранилища в настройках браузера. Удаление session приведет к выходу из учетной записи, удаление password_reset потребует повторного запуска восстановления доступа. Удаление или блокирование pb_device может ограничить участие в Pixel Battle, если без него невозможно обеспечить защиту мероприятия от злоупотреблений.",
        "number": "6.13.3."
      },
      {
        "type": "subheading",
        "number": "6.14",
        "text": "Публичные данные и распространение"
      },
      {
        "type": "paragraph",
        "text": "По инициативе Пользователя неопределенному кругу лиц могут быть доступны логин, отображаемое имя, изображение и описание профиля, сведения о подписках, стримы, записи, клипы, сообщения чата, комментарии, реакции, результаты мероприятий и иные сведения, которые Пользователь сознательно публикует с помощью функций сервиса.",
        "number": "6.14.1."
      },
      {
        "type": "paragraph",
        "text": "Если для распространения персональных данных требуется отдельное согласие, оно оформляется отдельно от других согласий и позволяет субъекту определить перечень распространяемых данных, условия и запреты. Молчание или бездействие не считаются согласием. Удаление публичного материала прекращает его дальнейшее отображение Оператором, но не гарантирует удаление копий, ранее законно сохраненных третьими лицами.",
        "number": "6.14.2."
      },
      {
        "type": "subheading",
        "number": "6.15",
        "text": "Получатели и инфраструктурная обработка"
      },
      {
        "type": "paragraph",
        "text": "Для достижения указанных целей данные могут предоставляться в необходимом объеме лицам, обрабатывающим их по поручению Оператора, включая поставщиков хостинга, баз данных, объектного хранения, доставки электронной почты, сетевой и медиатехнологической инфраструктуры, а при включении соответствующих функций — поставщика AI-модели или интеграционного сервиса. Также данные могут предоставляться государственным органам в случаях, установленных законом.",
        "number": "6.15.1."
      },
      {
        "type": "paragraph",
        "text": "Пользовательские файлы и сформированные медиаматериалы могут размещаться в S3-совместимом Yandex Object Storage. Конкретный перечень обработчиков, передаваемых им данных, мест обработки и сроков должен поддерживаться Оператором в актуальном состоянии и предоставляться субъекту по запросу.",
        "number": "6.15.2."
      },
      {
        "type": "paragraph",
        "text": "В действующей функциональности Оператор не собирает реквизиты банковских карт, ИНН и документы о постановке Пользователя на налоговый учет. До начала обработки таких сведений Оператор обязан определить отдельную цель, категории субъектов и данных, основание, получателей и сроки, а также обновить настоящую Политику.",
        "number": "6.15.3."
      },
      {
        "type": "subheading",
        "number": "6.16",
        "text": "Общие сроки и прекращение обработки"
      },
      {
        "type": "paragraph",
        "text": "По достижении цели, при утрате необходимости в данных, прекращении соответствующей функции, истечении срока согласия, его отзыве или поступлении законного требования Оператор прекращает обработку и уничтожает данные в сроки, установленные законом, если отсутствует иное правовое основание для их сохранения.",
        "number": "6.16.1."
      },
      {
        "type": "paragraph",
        "text": "Если конкретный срок прямо не указан выше, данные хранятся только в течение срока, объективно необходимого для заявленной цели. Продление хранения допускается исключительно при наличии предусмотренного законом основания. Обезличенные данные, не позволяющие определить субъекта без дополнительной информации, могут использоваться для статистики и улучшения сервиса.",
        "number": "6.16.2."
      },
      {
        "type": "heading",
        "number": "7",
        "text": "Условия обработки персональных данных"
      },
      {
        "type": "paragraph",
        "number": "7.1.",
        "text": "Обработка персональных данных осуществляется с согласия субъекта персональных данных на обработку его персональных данных."
      },
      {
        "type": "paragraph",
        "number": "7.2.",
        "text": "Обработка персональных данных необходима для достижения целей, предусмотренных международным договором Российской Федерации или законом, для осуществления возложенных законодательством Российской Федерации на оператора функций, полномочий и обязанностей."
      },
      {
        "type": "paragraph",
        "number": "7.3.",
        "text": "Обработка персональных данных необходима для осуществления правосудия, исполнения судебного акта, акта другого органа или должностного лица, подлежащих исполнению в соответствии с законодательством Российской Федерации об исполнительном производстве."
      },
      {
        "type": "paragraph",
        "number": "7.4.",
        "text": "Обработка персональных данных необходима для исполнения договора, стороной которого либо выгодоприобретателем или поручителем по которому является субъект персональных данных, а также для заключения договора по инициативе субъекта персональных данных или договора, по которому субъект персональных данных будет являться выгодоприобретателем или поручителем."
      },
      {
        "type": "paragraph",
        "number": "7.5.",
        "text": "Обработка персональных данных необходима для осуществления прав и законных интересов оператора или третьих лиц либо для достижения общественно значимых целей при условии, что при этом не нарушаются права и свободы субъекта персональных данных."
      },
      {
        "type": "paragraph",
        "number": "7.6.",
        "text": "Осуществляется обработка персональных данных, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных либо по его просьбе (далее — общедоступные персональные данные)."
      },
      {
        "type": "paragraph",
        "number": "7.7.",
        "text": "Осуществляется обработка персональных данных, подлежащих опубликованию или обязательному раскрытию в соответствии с федеральным законом."
      },
      {
        "type": "heading",
        "number": "8",
        "text": "Порядок сбора, хранения, передачи и других видов обработки персональных данных"
      },
      {
        "type": "paragraph",
        "text": "Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых, организационных и технических мер, необходимых для выполнения в полном объеме требований действующего законодательства в области защиты персональных данных."
      },
      {
        "type": "paragraph",
        "number": "8.1.",
        "text": "Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц."
      },
      {
        "type": "paragraph",
        "number": "8.2.",
        "text": "Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства либо в случае, если субъектом персональных данных дано согласие Оператору на передачу данных третьему лицу для исполнения обязательств по гражданско-правовому договору."
      },
      {
        "type": "paragraph",
        "number": "8.3.",
        "text": "В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно, путем направления Оператору уведомление на адрес электронной почты Оператора help@pantheone.ru с пометкой «Актуализация персональных данных»."
      },
      {
        "type": "paragraph",
        "number": "8.4.",
        "text": "Срок обработки персональных данных определяется достижением целей, для которых были собраны персональные данные, если иной срок не предусмотрен договором или действующим законодательством. Пользователь может в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору уведомление посредством электронной почты на электронный адрес Оператора help@pantheone.ru с пометкой «Отзыв согласия на обработку персональных данных»."
      },
      {
        "type": "paragraph",
        "number": "8.5.",
        "text": "Вся информация, которая собирается сторонними сервисами, в том числе платежными системами, средствами связи и другими поставщиками услуг, хранится и обрабатывается указанными лицами (Операторами) в соответствии с их Пользовательским соглашением и Политикой конфиденциальности. Субъект персональных данных и/или с указанными документами. Оператор не несет ответственность за действия третьих лиц, в том числе указанных в настоящем пункте поставщиков услуг."
      },
      {
        "type": "paragraph",
        "number": "8.6.",
        "text": "Установленные субъектом персональных данных запреты на передачу (кроме предоставления доступа), а также на обработку или условия обработки (кроме получения доступа) персональных данных, разрешенных для распространения, не действуют в случаях обработки персональных данных в государственных, общественных и иных публичных интересах, определенных законодательством РФ."
      },
      {
        "type": "paragraph",
        "number": "8.7.",
        "text": "Оператор при обработке персональных данных обеспечивает конфиденциальность персональных данных."
      },
      {
        "type": "paragraph",
        "number": "8.8.",
        "text": "Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных."
      },
      {
        "type": "paragraph",
        "number": "8.9.",
        "text": "Условием прекращения обработки персональных данных может являться достижение целей обработки персональных данных, истечение срока действия согласия субъекта персональных данных, отзыв согласия субъектом персональных данных или требование о прекращении обработки персональных данных, а также выявление неправомерной обработки персональных данных."
      },
      {
        "type": "heading",
        "number": "9",
        "text": "Перечень действий, производимых Оператором с полученными персональными данными"
      },
      {
        "type": "paragraph",
        "number": "9.1.",
        "text": "Оператор осуществляет сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление и уничтожение персональных данных."
      },
      {
        "type": "paragraph",
        "number": "9.2.",
        "text": "Оператор осуществляет автоматизированную обработку персональных данных с получением и/или передачей полученной информации по информационно-телекоммуникационным сетям или без таковой."
      },
      {
        "type": "heading",
        "number": "10",
        "text": "Трансграничная передача персональных данных"
      },
      {
        "type": "paragraph",
        "number": "10.1.",
        "text": "Оператор до начала осуществления деятельности по трансграничной передаче персональных данных обязан уведомить уполномоченный орган по защите прав субъектов персональных данных о своем намерении осуществлять трансграничную передачу персональных данных (такое уведомление направляется отдельно от уведомления о намерении осуществлять обработку персональных данных)."
      },
      {
        "type": "paragraph",
        "number": "10.2.",
        "text": "Оператор до подачи вышеуказанного уведомления, обязан получить от органов власти иностранного государства, иностранных физических лиц, иностранных юридических лиц, которым планируется трансграничная передача персональных данных, соответствующие сведения."
      },
      {
        "type": "heading",
        "number": "11",
        "text": "Конфиденциальность персональных данных"
      },
      {
        "type": "paragraph",
        "text": "Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим лицам и не распространять персональные данные без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом."
      },
      {
        "type": "heading",
        "number": "12",
        "text": "Заключительные положения"
      },
      {
        "type": "paragraph",
        "number": "12.1.",
        "text": "Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору с помощью электронной почты help@pantheone.ru."
      },
      {
        "type": "paragraph",
        "number": "12.2.",
        "text": "В данном документе будут отражены любые изменения политики обработки персональных данных Оператором. Политика действует бессрочно до замены ее новой версией."
      },
      {
        "type": "paragraph",
        "number": "12.3.",
        "text": "Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу https://docs.пантеон.com/privacy."
      }
    ]
  },
  "tos": {
    "slug": "tos",
    "title": "Пользовательское соглашение",
    "label": "Пользовательское соглашение",
    "eyebrow": "Правовые документы",
    "updated": "08 августа 2026 года",
    "blocks": [
      {
        "type": "paragraph",
        "text": "Настоящее пользовательское соглашение (далее — Соглашение) определяет порядок и условия использования материалов и сервисов, размещённых в сети Интернет по адресу https://пантеон.com (далее — Сайт) Пользователями (как этот термин определён ниже) данного Сайта. Использование Пользователями Сайта означает, что они безоговорочно принимают и обязуются соблюдать все условия настоящего Соглашения."
      },
      {
        "type": "heading",
        "number": "1",
        "text": "ОБЩИЕ ПОЛОЖЕНИЯ"
      },
      {
        "type": "paragraph",
        "number": "1.1.",
        "text": "В настоящем Соглашении, если из текста Соглашения прямо не вытекает иное, следующие указываемые в письменной форме с заглавной буквы слова и выражения, используемые при взаимодействии сторон в ходе исполнения обязательств, будут иметь указанные ниже значения:"
      },
      {
        "type": "definition",
        "term": "Администратор",
        "text": "Карпенко Максим Викторович, которому принадлежат все соответствующие права на Сайт."
      },
      {
        "type": "definition",
        "term": "Акцепт",
        "text": "полное и безоговорочное принятие условий настоящего Соглашения, размещённого на Сайте по адресу https://docs.пантеон.com/tos, осуществляемое путём совершения Пользователем любых действий по использованию Сайта."
      },
      {
        "type": "definition",
        "term": "Аутентификационные данные Пользователя",
        "text": "логин (адрес электронной почты Пользователя) и пароль (код доступа, который направляется Пользователю на указанный им в качестве логина адрес электронной почты), которые в совокупности признаются простой электронной подписью Пользователя. Пользователь самостоятельно обеспечивает сохранность своих Аутентификационных данных, а также возможность получения направляемых ему кодов доступа."
      },
      {
        "type": "definition",
        "term": "Пользователь",
        "text": "лицо, осуществляющее доступ к Сайту и использующее материалы и сервисы, размещённые на Сайте."
      },
      {
        "type": "definition",
        "term": "Контент",
        "text": "любое информационно значимое наполнение Сайта, включая, но не ограничиваясь, фото, аудио, видео, текст и иные медиаматериалы."
      },
      {
        "type": "definition",
        "term": "Личный кабинет",
        "text": "персонализированная часть Сайта, посредством которой обеспечивается обмен информацией и документацией в электронном виде между Пользователем и Сайтом. Доступ к Личному кабинету осуществляется путём ввода Пользователем Аутентификационных данных."
      },
      {
        "type": "definition",
        "term": "Персональные данные",
        "text": "любая информация, относящаяся к определённому или определяемому на основании такой информации физическому лицу (субъекту персональных данных), в том числе его фамилия, имя, отчество, год, месяц, день и место рождения, адрес, семейное, социальное, имущественное положение, образование, профессия, доходы, другая информация."
      },
      {
        "type": "definition",
        "term": "Обработка персональных данных",
        "text": "любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных."
      },
      {
        "type": "definition",
        "term": "Сайт",
        "text": "ресурс в сети Интернет, представляющий собой совокупность содержащихся в информационной системе информации и объектов интеллектуальной собственности (в том числе программа для ЭВМ, база данных, графическое оформление интерфейса (дизайн) и др.), доступ к которому обеспечивается с различных пользовательских устройств, подключённых к сети Интернет, посредством специального программного обеспечения для просмотра веб-страниц (браузер) по сетевому адресу https://пантеон.com (и адресам подразделов Сайта)."
      },
      {
        "type": "paragraph",
        "number": "1.2.",
        "text": "Все остальные термины и определения, встречающиеся в тексте Соглашения, толкуются в соответствии с действующим законодательством Российской Федерации."
      },
      {
        "type": "heading",
        "number": "2",
        "text": "ПРЕДМЕТ СОГЛАШЕНИЯ"
      },
      {
        "type": "paragraph",
        "number": "2.1.",
        "text": "В соответствии с настоящим Соглашением Администратор предоставляет любому Пользователю право безвозмездного использования Сайта любым способом и в любой форме в пределах его объявленных функциональных возможностей и на условиях, изложенных в настоящем Соглашении."
      },
      {
        "type": "paragraph",
        "number": "2.2.",
        "text": "Использование Сайта осуществляется в соответствии с принятым в мировой правоприменительной практике принципом «как есть» (as is). В соответствии с данным принципом никакие гарантии, что Сайт будет соответствовать всем требованиям Пользователя, работать непрерывно, быстро и без ошибок; результаты, которые могут быть получены с использованием Сайта, будут точными и надёжными не прилагаются и не предусматриваются."
      },
      {
        "type": "paragraph",
        "number": "2.3.",
        "text": "Пользователь считается присоединившимся к настоящему Соглашению в соответствии с положениями статьи 438 ГК РФ, получая доступ к материалам и сервисам Сайта и осуществляя использование Сайта любым способом и в любой форме в пределах его функциональных возможностей, включая:"
      },
      {
        "type": "paragraph",
        "number": "2.3.1.",
        "text": "просмотр материалов, размещённых на Сайте;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "2.3.2.",
        "text": "использование сервисов Сайта;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "2.3.3.",
        "text": "регистрация в Личном кабинете;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "2.3.4.",
        "text": "направление любых сообщений с использованием онлайн-форм на Сайте;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "2.3.5.",
        "text": "иное использование Сайта.",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "2.4.",
        "text": "Используя Сайт в порядке, предусмотренном п. 2.3 Соглашения, Пользователь подтверждает, что:"
      },
      {
        "type": "paragraph",
        "number": "2.4.1.",
        "text": "ознакомился с условиями настоящего Соглашения в полном объёме до начала использования Сайта;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "2.4.2.",
        "text": "безоговорочно принимает все условия настоящего Соглашения в полном объёме без каких-либо изъятий и ограничений, а также обязуется соблюдать их или прекратить использование Сайта в случае несогласия с условиями настоящего Соглашения.",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "2.5.",
        "text": "Никакое из положений Соглашения не может трактоваться как установление между Администратором и Пользователем агентских отношений, отношений по ведению совместной деятельности или каких-либо иных правоотношений, прямо не предусмотренных настоящим Соглашением."
      },
      {
        "type": "paragraph",
        "number": "2.6.",
        "text": "Все возможные споры, вытекающие из настоящего Соглашения или связанные с ним, подлежат разрешению в соответствии с действующим законодательством Российской Федерации."
      },
      {
        "type": "paragraph",
        "number": "2.7.",
        "text": "Порядок исполнения обязательств, возникающих в соответствии с иными договорами, заключаемыми между Пользователем и Администратором, устанавливается в таких договорах."
      },
      {
        "type": "heading",
        "number": "3",
        "text": "РЕГИСТРАЦИЯ"
      },
      {
        "type": "paragraph",
        "number": "3.1.",
        "text": "Для использования отдельного функционала Сайта Пользователю необходимо пройти процедуру регистрации, в результате которой ему будет предоставлен персональный доступ в Личный кабинет."
      },
      {
        "type": "paragraph",
        "number": "3.2.",
        "text": "В процессе регистрации Пользователь обязуется достоверно и полно заполнить информацию о себе по вопросам, предлагаемым в форме регистрации, и поддерживать эту информацию в актуальном состоянии. Если Пользователь предоставил неверную информацию или у Администратора есть основания полагать, что предоставленная Пользователем информация неполна или недостоверна, Администратор имеет право по своему усмотрению заблокировать доступ в Личный кабинет либо удалить учётную запись Пользователя и отказать Пользователю в использовании отдельного функционала Сайта."
      },
      {
        "type": "paragraph",
        "number": "3.3.",
        "text": "Администратор вправе потребовать от Пользователя подтверждения данных, указанных при регистрации, и запросить в связи с этим подтверждающие документы. В случае если данные Пользователя, указанные в предоставленных им документах, не соответствуют данным, указанным при регистрации, а также в случае, когда данные, указанные при регистрации, не позволяют идентифицировать Пользователя, Администратор вправе отказать Пользователю в доступе в Личный кабинет и использовании Сайта."
      },
      {
        "type": "paragraph",
        "number": "3.4.",
        "text": "Пользователь подтверждает и гарантирует, что все действия, предусмотренные для Пользователя настоящим Соглашением, совершаются лицом, чьи данные направлены Администратору при прохождении процедуры регистрации."
      },
      {
        "type": "paragraph",
        "number": "3.5.",
        "text": "Пользователь самостоятельно несёт ответственность за безопасность и сохранность своих Аутентификационных данных. Пользователь самостоятельно несёт ответственность за все действия (а также их последствия) при использовании Сайта под Аутентификационными данными Пользователя, такие действия считаются произведёнными самим Пользователем."
      },
      {
        "type": "paragraph",
        "number": "3.6.",
        "text": "Пользователь обязан немедленно уведомить Администратора о любом случае несанкционированного доступа к Личному кабинету Пользователя и (или) о любом нарушении (подозрениях о нарушении) конфиденциальности своего пароля."
      },
      {
        "type": "paragraph",
        "number": "3.7.",
        "text": "Пользователь не вправе воспроизводить, повторять и копировать, продавать и перепродавать, а также использовать для каких-либо коммерческих целей Сайт, его Контент или доступ к нему, кроме тех случаев, когда Пользователь получил такое разрешение от Администратора либо когда это прямо предусмотрено настоящим Соглашением."
      },
      {
        "type": "paragraph",
        "number": "3.8.",
        "text": "При регистрации на Сайте Пользователь даёт согласие на получение от Администратора рассылок, пуш-уведомлений, смс-уведомлений и иных уведомлений рекламно-информационного характера. Настройка параметров рассылки (периодичность получения, возможность и способы отказа от рассылки и пр.) будет возможна для Пользователя непосредственно через сообщения на электронную почту Администратора или по телефону. Рассылки поступают в виде электронного письма на адрес, звонка и (или) короткого сообщения (смс, пуш или аналог) на номер телефона, указанный Пользователем при регистрации. Рекламно-информационные материалы могут предоставляться в виде бумажно-полиграфической и сувенирной продукции, вкладываться в заказы клиентов и доставляться на указанный почтовый адрес в виде писем и посылок."
      },
      {
        "type": "heading",
        "number": "4",
        "text": "ПРАВА И ОБЯЗАННОСТИ АДМИНИСТРАТОРА"
      },
      {
        "type": "paragraph",
        "number": "4.1.",
        "text": "В целях повышения качества Сайта Администратор или действующие по его поручению лица вправе осуществлять сбор мнений и отзывов Пользователей по различным вопросам путём направления информационных сообщений при очередном посещении Пользователем Сайта либо осуществления связи по контактным данным, указанным Пользователем при регистрации Личного кабинета, посредством телефонных звонков или электронных писем. Собранные мнения и отзывы могут быть использованы для формирования статистических данных, которые могут быть использованы в сервисах, реализуемых на Сайте. Отзывы, предоставленные Пользователем при проведении опроса, также могут быть опубликованы (или обнародованы иным способом) Администратором."
      },
      {
        "type": "paragraph",
        "number": "4.2.",
        "text": "Администратор вправе направлять на адрес электронной почты и (или) абонентский номер Пользователя информационные сообщения, в том числе, но не ограничиваясь, сообщения, связанные с функционированием Сайта, уведомления, связанные с исполнением договоров, заключённых с Пользователем, информацию о восстановлении пароля и т. д. Подтверждением согласия Пользователя на получение от Администратора указанных в настоящем пункте информационных сообщений является принятие условий Соглашения."
      },
      {
        "type": "paragraph",
        "number": "4.3.",
        "text": "Администратор оставляет за собой право заблокировать Личный кабинет Пользователя в соответствии с условиями Соглашения либо в случае нарушения Пользователем условий настоящего Соглашения."
      },
      {
        "type": "paragraph",
        "number": "4.4.",
        "text": "Сайт или его сервисы могут быть в то или иное время частично или полностью недоступны по причине проведения профилактических или иных работ или по любым другим причинам технического характера. Администратор вправе производить модификацию любого программного обеспечения Сайта, проводить необходимые профилактические или иные работы, приостанавливать работу Сайта в то или иное время по личному усмотрению с предварительным уведомлением Пользователя или без такового."
      },
      {
        "type": "paragraph",
        "number": "4.5.",
        "text": "Администратор не несёт ответственности за любые ошибки, упущения, прерывания, удаление, дефекты, задержку в обработке или передаче данных, сбое линий связи, кражу, уничтожение или неправомерный доступ к информации Пользователя, размещённой на Сайте или в любом другом месте. Администратор не отвечает за любые технические сбои или иные проблемы любых телефонных сетей или служб, компьютерных систем, серверов или провайдеров, компьютерного или телефонного оборудования, программного обеспечения, сбоев сервисов электронной почты или скриптов по техническим причинам."
      },
      {
        "type": "paragraph",
        "number": "4.6.",
        "text": "В течение срока действия настоящего Соглашения Администратор предпримет все усилия для устранения каких-либо технических сбоев и ошибок в случае их возникновения в разумный срок. При этом Администратор не гарантирует полного отсутствия технических ошибок и сбоев по причинам, вызванным неисправностью оборудования, некорректной работой программного обеспечения либо программной среды."
      },
      {
        "type": "paragraph",
        "number": "4.7.",
        "text": "Пользователю не предоставляется никаких интеллектуальных прав, за исключением прямо предусмотренных настоящим Соглашением, в отношении как Сайта в целом, так и в отношении отдельного программного обеспечения, дизайнерских решений, литературных, графических и аудиовизуальных произведений, входящих в состав Сайта."
      },
      {
        "type": "heading",
        "number": "5",
        "text": "ПРАВА И ОБЯЗАННОСТИ ПОЛЬЗОВАТЕЛЯ"
      },
      {
        "type": "paragraph",
        "number": "5.1.",
        "text": "Пользователь обязуется знакомиться с актуальной версией Соглашения при каждом посещении Сайта до начала использования функционала Сайта и соблюдать его условия."
      },
      {
        "type": "paragraph",
        "number": "5.2.",
        "text": "Пользователь обязуется предоставлять достоверную и полную информацию при использовании Сайта."
      },
      {
        "type": "paragraph",
        "number": "5.3.",
        "text": "Пользователь соглашается не предпринимать действий и не оставлять комментарии и записи, которые могут рассматриваться как нарушающие российское законодательство или нормы международного права, в том числе в сфере интеллектуальной собственности, авторских и (или) смежных прав, общепринятые нормы морали и нравственности, а также любых действий, которые приводят или могут привести к нарушению нормальной работы Сайта."
      },
      {
        "type": "paragraph",
        "number": "5.4.",
        "text": "Использование материалов Сайта без согласия правообладателей не допускается."
      },
      {
        "type": "paragraph",
        "number": "5.5.",
        "text": "При цитировании материалов Сайта, включая охраняемые авторские произведения, ссылка на Сайт обязательна."
      },
      {
        "type": "paragraph",
        "number": "5.6.",
        "text": "Пользователь обязуется нести ответственность за все действия, совершённые при использовании его Личного кабинета, а также за последствия, вызванные такими действиями."
      },
      {
        "type": "paragraph",
        "number": "5.7.",
        "text": "При использовании Сайта Пользователь не вправе нарушать права и законные интересы третьих лиц, а также причинять вред в какой-либо форме, включая вред деловой репутации."
      },
      {
        "type": "paragraph",
        "number": "5.8.",
        "text": "Пользователь не вправе нарушать нормальную работу как отдельных сервисов Сайта, так и Сайта в целом."
      },
      {
        "type": "paragraph",
        "number": "5.9.",
        "text": "Пользователь обязан самостоятельно отслеживать внесение изменений в настоящее Соглашение."
      },
      {
        "type": "paragraph",
        "number": "5.10.",
        "text": "Пользователь вправе прекратить доступ к Личному кабинету путём направления соответствующего уведомления Администратору."
      },
      {
        "type": "heading",
        "number": "6",
        "text": "ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ АДМИНИСТРАТОРА"
      },
      {
        "type": "paragraph",
        "number": "6.1.",
        "text": "Администратор гарантирует достоверность, точность, полноту или качество только той информации, которую он сам непосредственно разместил на Сайте. Администратор не несёт ответственности за достоверность, точность, полноту и качество информации, размещённой на Сайте третьими лицами, в том числе Пользователями."
      },
      {
        "type": "paragraph",
        "number": "6.2.",
        "text": "Администратор не несёт ответственности за некорректное поведение лиц, использующих Сайт."
      },
      {
        "type": "paragraph",
        "number": "6.3.",
        "text": "Администратор не гарантирует, что:"
      },
      {
        "type": "paragraph",
        "number": "6.3.1.",
        "text": "Сайт будет соответствовать требованиям Пользователя;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "6.3.2.",
        "text": "результаты, которые могут быть получены с использованием Сайта, будут точными и надёжными;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "6.3.3.",
        "text": "качество какого-либо продукта, услуг, информации, полученных с использованием Сайта, будет соответствовать ожиданиям Пользователя;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "6.3.4.",
        "text": "Сайт будет работать непрерывно, быстро, надёжно и без ошибок и будет соответствовать ожиданиям Пользователя;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "6.3.5.",
        "text": "все ошибки на Сайте будут исправлены.",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "6.4.",
        "text": "Администратор не несёт ответственности и не имеет прямых или косвенных обязательств перед Пользователем в связи с любыми возможными или возникшими потерями или убытками, связанными с любым содержанием Сайта, регистрацией авторских прав и сведениями о такой регистрации, товарами или услугами, доступными или полученными через внешние сайты или ресурсы либо иные контакты Пользователя, в которые он вступил, используя размещённую на Сайте информацию или ссылки на внешние ресурсы."
      },
      {
        "type": "paragraph",
        "number": "6.5.",
        "text": "Администратор не несёт ответственности за полноту и достоверность сведений, предоставляемых Пользователями при осуществлении регистрационных действий на Сайте, а также не отвечает за возможный ущерб, связанный с недостоверностью или неполнотой таких сведений. Администратор не принимает на себя никаких обязательств по проверке достоверности Персональных данных, указанных Пользователем, и не несёт ответственности в случае, если Пользователь предоставит больший объём данных, чем это предусмотрено соответствующими формами на Сайте."
      },
      {
        "type": "paragraph",
        "number": "6.6.",
        "text": "Администратор не несёт ответственности перед Пользователем или любыми другими третьими лицами и не возмещает любой ущерб, включая упущенную выгоду или потерянные данные, вред, причинённый чести, достоинству или деловой репутации, и иные убытки, причинённые в связи с использованием Сайта или иных материалов и сервисов, содержащихся на Сайте, за исключением случаев, прямо предусмотренных Соглашением."
      },
      {
        "type": "paragraph",
        "number": "6.7.",
        "text": "Администратор исходит из того, что все формы на Сайте заполняет непосредственно Пользователь. Ответственность за правомерность предоставления и достоверность Персональных данных Пользователя и иных лиц, данные которых сообщены, несёт исключительно Пользователь."
      },
      {
        "type": "paragraph",
        "number": "6.8.",
        "text": "Администратор не несёт ответственности за утрату, подмену или порчу данных, а также за иные последствия, наступившие в результате невыполнения Пользователем условий, предусмотренных настоящим Соглашением."
      },
      {
        "type": "paragraph",
        "number": "6.9.",
        "text": "Администратор не несёт ответственности за организацию использования протоколов OpenID и OAuth третьими лицами и надлежащее обеспечение ими защиты информации о Пользователях, а также получение законного предварительного согласия Пользователей на обработку Администратором их Персональных данных в рамках использования указанных протоколов."
      },
      {
        "type": "heading",
        "number": "7",
        "text": "ДОСТУП К РЕСУРСАМ ТРЕТЬИХ ЛИЦ"
      },
      {
        "type": "paragraph",
        "number": "7.1.",
        "text": "Доступ Пользователя к Сайту может вызвать обращение на интернет-ресурсы третьих лиц и загрузку с них программного кода или графических объектов (в том числе невидимых при отображении интернет-страниц браузером), используемых в рекламных целях и в целях сбора статистики. Владельцы интернет-ресурсов имеют техническую возможность осуществлять сбор информации о Пользователях и самостоятельно определяют условия её использования."
      },
      {
        "type": "paragraph",
        "number": "7.2.",
        "text": "Пользователь имеет возможность заблокировать запросы на графические изображения, размещённые на серверах третьих лиц, путём настройки программного обеспечения. Блокировка может привести к потере читаемости и появлению ошибок при отображении ресурсов."
      },
      {
        "type": "paragraph",
        "number": "7.3.",
        "text": "При переходе Пользователей с Сайта на страницы интернет-ресурсов третьих лиц Пользователи самостоятельно определяют пределы использования информации о них в рамках условий и правил, определяемых владельцами соответствующих интернет-ресурсов. Последние при этом имеют технологическую возможность доступа к информации, хранящейся на стороне браузера, и несут ответственность за соблюдение прав Пользователей в связи с её использованием."
      },
      {
        "type": "heading",
        "number": "8",
        "text": "ИСПОЛЬЗОВАНИЕ ИНФОРМАЦИИ, ХРАНЯЩЕЙСЯ НА СТОРОНЕ БРАУЗЕРА"
      },
      {
        "type": "paragraph",
        "number": "8.1.",
        "text": "Администратор использует информацию, хранящуюся на стороне браузера Пользователя, для определения уникального идентификатора доступа Пользователя к Сайту с целью:"
      },
      {
        "type": "paragraph",
        "number": "8.1.1.",
        "text": "поддержки функциональности ресурсов, требующих использования информации, хранящейся на стороне браузера;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "8.1.2.",
        "text": "измерения размеров аудитории Сайта;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "8.1.3.",
        "text": "определения статистических информационных предпочтений Пользователей при доступе к различным страницам Сайта;",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "8.1.4.",
        "text": "определения в исследовательских целях корреляции статистических данных о посещаемости Сайта с социометрическими данными о Пользователях.",
        "depth": 2
      },
      {
        "type": "paragraph",
        "number": "8.2.",
        "text": "Путём настройки программного обеспечения Пользователь имеет возможность запретить использование информации, хранящейся на стороне браузера, на своём компьютере, однако это может привести к частичной или полной потере функциональности страниц Сайта."
      },
      {
        "type": "heading",
        "number": "9",
        "text": "СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ"
      },
      {
        "type": "paragraph",
        "number": "9.1.",
        "text": "Обработка персональных данных Пользователей осуществляется Администратором в соответствии с политикой конфиденциальности, размещённой по адресу https://пантеон.com/privacy."
      },
      {
        "type": "heading",
        "number": "10",
        "text": "ИЗМЕНЕНИЕ УСЛОВИЙ И РАСТОРЖЕНИЕ СОГЛАШЕНИЯ"
      },
      {
        "type": "paragraph",
        "number": "10.1.",
        "text": "Соглашение может быть расторгнуто в любое время по инициативе любой из сторон. Для этого Администратор размещает уведомление о расторжении Соглашения на Сайте и (или) направляет Пользователю соответствующее уведомление по адресу электронной почты, указанному Пользователем при регистрации, с момента такого размещения / направления такого уведомления Соглашение считается расторгнутым."
      },
      {
        "type": "paragraph",
        "number": "10.2.",
        "text": "Пользователь может расторгнуть настоящее Соглашение путём направления Администратору уведомления о расторжении по электронной почте на адрес help@pantheone.ru."
      },
      {
        "type": "paragraph",
        "number": "10.3.",
        "text": "Пользователь соглашается, что настоящее Соглашение может быть изменено Администратором в одностороннем порядке путём размещения обновлённого текста Соглашения в сети Интернет. Пользователь подтверждает своё согласие с изменениями условий Соглашения путём использования Сайта. При несогласии с изменённой версией Соглашения Пользователь обязуется прекратить использование Сайта."
      },
      {
        "type": "heading",
        "number": "11",
        "text": "ИНФОРМАЦИЯ ОБ АДМИНИСТРАТОРЕ"
      },
      {
        "type": "paragraph",
        "text": "ФИО: Карпенко Максим Викторович"
      },
      {
        "type": "paragraph",
        "text": "ИНН: 072602727850"
      },
      {
        "type": "paragraph",
        "text": "Статус: физическое лицо, применяющее специальный налоговый режим «Налог на профессиональный доход»"
      },
      {
        "type": "paragraph",
        "text": "Адрес электронной почты: help@pantheone.ru"
      }
    ]
  }
};
